<template>
  <CDropdown
    v-if="activeSchool"
    variant="nav-item"
    class="c-header-nav-items header-school-dropdown"
    placement="bottom-end"
    add-menu-classes="p-0 shadow-none"
    :class="{ 'student-school': noSchoolOptions }"
    data-test-id="header-school-dropdown"
  >
    <CDropdownToggle component="button" @click="(e) => e.preventDefault()">
      <div
        class="d-flex align-items-center"
        :class="{ 'cursor-default': noSchoolOptions }"
      >
        <div class="c-avatar active-school me-1 me-md-3">
          <img
            width="50"
            :src="
              activeSchool.logo
                ? activeSchool.logo
                : '/img/avatars/school-avatar.png'
            "
            class="c-avatar-img"
          />
        </div>
        <b class="flex-grow-1" data-test-id="header-school-name">{{
          activeSchool.name
        }}</b>
      </div>
    </CDropdownToggle>
    <CDropdownMenu
      v-if="!noSchoolOptions"
      class="header-school-options school-select p-0"
    >
      <CDropdownItem
        v-for="(school, index) in schoolOptions"
        :key="index"
        class="px-2 cursor-pointer"
      >
        <div
          class="d-flex align-items-center school-container py-2"
          @click="setActiveSchool(school)"
        >
          <div class="c-avatar me-1 school-avatar">
            <img
              width="50"
              :src="
                school.logo ? school.logo : '/img/avatars/school-avatar.png'
              "
              class="c-avatar-img"
            />
          </div>

          <div
            class="text-start school-name flex-grow-1"
            data-test-id="header-school-list"
          >
            {{ school.name }}
          </div>
        </div>
      </CDropdownItem>
    </CDropdownMenu>
  </CDropdown>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "TheHeaderDropdownAccnt",
  data() {
    return {
      schoolSelectHeight: null,
      isSelectScrolable: false
    }
  },
  computed: {
    ...mapState({
      schools: (state) => state.schools.schools,
      activeSchool: (state) => state.schools.activeSchool
    }),
    schoolOptions() {
      return this.schools && this.schools.length
        ? this.schools.filter((el) => el.id !== this.activeSchool.id)
        : []
    },
    noSchoolOptions() {
      return !this.schoolOptions.length
    }
  },
  mounted() {
    this.initSchoolsSelectSize()
  },
  methods: {
    setActiveSchool(school) {
      if (school && school.name !== this.activeSchool.name) {
        this.$store.dispatch("schools/changeActiveSchool", school)
      }
    },
    initSchoolsSelectSize() {
      const body = document.getElementsByClassName("main-scroll-container")[0]
      if (this.schoolOptions && body) {
        this.isSelectScrolable =
          this.schoolOptions.length * 77 + 100 > body.offsetHeight
      }
      this.schoolSelectHeight =
        body && this.schoolOptions && this.isSelectScrolable
          ? body.offsetHeight + "px"
          : "auto"
    }
  }
}
</script>
<style scoped>
.school-select {
  overflow: auto;
  width: 208px;
}
</style>
